import { render } from "./UserMenu.vue?vue&type=template&id=04e26a88&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"

import "./UserMenu.vue?vue&type=style&index=0&id=04e26a88&lang=scss&scoped=true"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e26a88"]])

export default __exports__